import { ID } from '@griply/types';

export const toggleIdInList = (list: ID[] | null | undefined, id: ID): ID[] => {
  const current = list ?? [];

  if (current.includes(id)) {
    return current.filter((existing) => existing !== id);
  }

  return [...current, id];
};
